<template>
  <div class="auth-layout-view">
    <user-profile>
      <router-view/>
    </user-profile>
  </div>
</template>

<script>
import UserProfile from '../../../components/user-profile/user-profile'
export default {
  name: 'UserProfileView',
  components: {
    UserProfile
  }
}
</script>

<style lang="scss" scoped>
  .auth-layout-view {
  }

</style>



// WEBPACK FOOTER //
// src/views/app/user-profile/user-profile-layout.view.vue